import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const FazitAbschlussberichtEmob: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<ApplicationHeading title="Fazit und Ausblick" description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};

export default FazitAbschlussberichtEmob;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Abschlussbericht_Elektro_0219735687_it_Und_Ausblick_Beschreibung],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucFazitAbschlussberichtEmob = () => {
	return concat(formStruc());
};
